import { render } from "./LoginBlackImage.vue?vue&type=template&id=60efd54b"
import script from "./LoginBlackImage.vue?vue&type=script&scoped=true&lang=js"
export * from "./LoginBlackImage.vue?vue&type=script&scoped=true&lang=js"

import "./LoginBlackImage.vue?vue&type=style&index=0&id=60efd54b&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__